import React from "react";
import { CLIENTS } from "../data/content";
import "../styles/clientCarousel.css";

/**
 * Infinite-scrolling client logo carousel. Renders each client as a clean
 * wordmark chip (initials + name) so it works before real logo files are
 * dropped in — swap the chip markup for <img src={client.logo} /> once
 * actual client logo assets are available.
 */
function ClientLogoCarousel() {
  // Render the list twice back-to-back so the CSS marquee can loop seamlessly.
  const track = [...CLIENTS];

  return (
    <div
      className="client-logo-container"
      role="region"
      aria-label="Trusted by"
    >
      {track.map((client, index) => (
        <div className="client-logo" key={`${client.name}-${index}`}>
          <img
            src={client.logo}
            alt="Client logo"
            className="client-logo-image"
          />
        </div>
      ))}
    </div>
  );
}

// function ClientLogoCarousel() {
//   return (
//     <div
//       className="client-logo-container"
//       role="region"
//       aria-label="Trusted by"
//     >
//       <img src={clientLogo} alt="Client logo" className="client-logo-image" />
//     </div>
//   );
// }

export default ClientLogoCarousel;
